import safePromoCleanerCloudDarkMp4 from 'img/safe/safePromoCleanerCloud_dark.mp4';
import safePromoCleanerCloudDarkWebm from 'img/safe/safePromoCleanerCloud_dark.webm';
import safePromoCleanerCloudLightMp4 from 'img/safe/safePromoCleanerCloud_light.mp4';
import safePromoCleanerCloudLightWebm from 'img/safe/safePromoCleanerCloud_light.webm';
import safePromoCleanerMailDarkMp4 from 'img/safe/safePromoCleanerMail_dark.mp4';
import safePromoCleanerMailDarkWebm from 'img/safe/safePromoCleanerMail_dark.webm';
import safePromoCleanerMailLightMp4 from 'img/safe/safePromoCleanerMail_light.mp4';
import safePromoCleanerMailLightWebm from 'img/safe/safePromoCleanerMail_light.webm';
import defaultMovedFilesCoverDarkMobile from 'img/safe/safePromoDarkMobile.png';
import defaultMovedLettersCoverDarkMobile from 'img/safe/safePromoLettersDarkMobile.png';
import defaultMovedFilesCoverLightMobile from 'img/safe/safePromoLightMobile.png';
import { quotaCleanerMobileVideoCovers } from 'reactApp/appHelpers/featuresHelpers/features/quotaCleaner';
import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import { isDarkThemeModeEnabled } from 'reactApp/utils/theme';

import type { FastCleanerSafeModalProps } from './FastCleanerSafeModal';

export const renderFastCleanSafeModal = (data?: FastCleanerSafeModalProps) => {
    openPopupHelper({ popupName: popupNames.FAST_CLEANER_SAFE, data, onClose: data?.onClose });
};

export type VideoCoverImg = { webm: string; mp4: string };

export const fastCleanerSafeCoverConfig: Record<
    'letters' | 'files',
    Record<'images' | 'video', { dark: string | VideoCoverImg; light: string | VideoCoverImg }>
> = {
    letters: {
        video: {
            dark: { webm: safePromoCleanerMailDarkWebm, mp4: safePromoCleanerMailDarkMp4 },
            light: { webm: safePromoCleanerMailLightWebm, mp4: safePromoCleanerMailLightMp4 },
        },
        images: {
            dark: defaultMovedLettersCoverDarkMobile,
            light: defaultMovedLettersCoverDarkMobile,
        },
    },
    files: {
        video: {
            dark: { webm: safePromoCleanerCloudDarkWebm, mp4: safePromoCleanerCloudDarkMp4 },
            light: { webm: safePromoCleanerCloudLightWebm, mp4: safePromoCleanerCloudLightMp4 },
        },
        images: {
            dark: defaultMovedFilesCoverDarkMobile,
            light: defaultMovedFilesCoverLightMobile,
        },
    },
};

export const isVideoCover = (cover: string | VideoCoverImg) => {
    return typeof cover === 'object';
};

export type FastCleanSafeModalCoverType = keyof typeof fastCleanerSafeCoverConfig;

export const getFastCleanSafeModalCoverImage = (coverType: FastCleanSafeModalCoverType): string | VideoCoverImg => {
    const isDarkTheme = isDarkThemeModeEnabled();

    const coverConfig = fastCleanerSafeCoverConfig[coverType] || fastCleanerSafeCoverConfig.files;

    if (quotaCleanerMobileVideoCovers) {
        return isDarkTheme ? coverConfig.video.dark : coverConfig.video.light;
    }

    return isDarkTheme ? coverConfig.images.dark : coverConfig.images.light;
};
